import { ref, computed } from "vue";
import { defineStore } from "pinia";
import type { BeforeInstallPromptEvent } from "@/types/events/before-install-prompt-event";

/**
 * Prompts store for managing PWA install prompts
 * Uses Pinia with Composition API and TypeScript
 */
export const usePromptsStore = defineStore("prompts", () => {
  /* State */
  const pwaInstallPrompt = ref<BeforeInstallPromptEvent | null>(null);

  /* Computed / Getters */
  const hasPwaInstallPrompt = computed(() => pwaInstallPrompt.value !== null);

  /* Actions */
  function setPwaInstallPrompt(prompt: BeforeInstallPromptEvent | null): void {
    pwaInstallPrompt.value = prompt;
  }

  function reset(): void {
    pwaInstallPrompt.value = null;
  }

  /* Exposed store */
  return {
    // State
    pwaInstallPrompt,

    // Computed
    hasPwaInstallPrompt,

    // Actions
    setPwaInstallPrompt,
    reset,
  };
});
